module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-03.1.f00a4714.jpg";